// ITEM 12 — **THE MAGIC ROOM'S EDGE CONTROLS, LIFTED OUT OF App.tsx SO A GATE CAN CALL THEM.**
//
// MR-NP + MR-IN: the controls that stand at the room's edge rather than as a panel over the art.
// W1-11(a): TOP right, bigger, FIXED, clear of the rail — the measurement is in `styles.css`, and
// MR-MOB anchors them below the REAL nav height because a hand-typed `top` here is what put them on
// the header in the first place.
//
// **IT MOVED FOR THE REASON THIS FILE'S NEIGHBOURS ALL MOVED (R7/R8): it is hookless, so a gate CALLS
// it** — props in, tree out, no state, no hook. Inside a 12,000-line TSX file the only thing any
// instrument could ever ask about these three buttons was whether some characters appeared in a
// source file; out here `scripts/file-cabinet.mjs` reads the tree back. And it is this round's
// payment on the R8 ceiling, which the file cabinet's door would otherwise have pushed through
// (roadmap 7 ratchets that number DOWN, never up, and a round that needs lines pays them).
//
// **EACH CONTROL DECIDES ITS OWN GATE, AND THE THIRD ONE DELIBERATELY HAS NONE.** The Notepaper and
// the File Cabinet are things a member OPENS and both go through `onRequireMembership`, so a member
// below the tier meets T8-3's purple box rather than an empty panel. "How this room works" is the
// explanation of the room she is standing in and asks for nothing — a wall in front of the sentence
// that tells her what the room is would be the one refusal with nothing behind it.
import { ScrollText, Archive, Compass } from "lucide-react";
import type { MagicView } from "../catalogs/magic-books";

export function MagicEdgeControls({
  isMember, onOpen, onInstructions, onRequireMembership,
}: {
  isMember: boolean;
  onOpen: (view: MagicView) => void;
  onInstructions: () => void;
  onRequireMembership: (action: () => void) => void;
}) {
  const open = (view: MagicView) => () => (isMember ? onOpen(view) : onRequireMembership(() => onOpen(view)));
  return (
    <div className="mr-edge-controls">
      <button type="button" className="mr-edge-btn mr-edge-btn--parchment" onClick={open("notepaper")}>
        <ScrollText size={18} /> Notepaper
      </button>
      {/* ITEM 12 — THE FILE CABINET'S DOOR. It stands with the Notepaper at the room's edge rather
          than becoming a seventh book on the shelf: the shelf tiles ARE her painted art (MR-ART) and
          there is no cabinet in the painting, so a tile would need a picture this house does not
          have. Named rather than assumed (DECISIONS ITEM12-1). */}
      <button type="button" className="mr-edge-btn mr-edge-btn--cabinet" onClick={open("cabinet")}>
        <Archive size={18} /> File Cabinet
      </button>
      <button type="button" className="mr-edge-btn mr-edge-btn--glow" onClick={onInstructions}>
        <Compass size={18} /> How this room works
      </button>
    </div>
  );
}
